import { functions } from './firebase';

export const makeBooking = async (slotRef, memberId) => {
  // console.log("will call booking for memberId: ", memberId);
  try {
    await functions.httpsCallable('makeBookingForMemberId')({
      slotRefPath: slotRef.path,
      memberId,
    });
    return { success: true, message: "Bokning klar" };
  } catch (error) {
    console.error("Could not make booking for member id. ", error.message);
    // alert(error.message);
    if (error.code === 'invalid-argument') {
      // alert(error.message);
    }
    return { success: false, message: "Kunde inte boka. " + error.message };
  }
};